import { SoilAnalysisType } from "../shared/generated/enums";
import { getMorganColor, getMorganColors, getMorganKey } from "../shared/soil/colors/morgan";
import { getGaugeStyle, getSoilColors, getValueIndex } from "../shared/soil/colors/olsen";
import { conversions, convertAnalysisAttributeToUnit, convertMorganToOlsen, convertOlsenToMorgan } from "../shared/soil/conversions";
import { SoilMapView } from "../shared/soil/mapView";
import { getMorganAttribute, getMorganIndexTextFromValue } from "../shared/soil/morgan";
import { infiltrationRateOptions, vessOptions, wormTypeOptions } from "../shared/soil/plan";
import { getSoilUnitLabel, getSoilUnitOption, getSoilUnitOptions, getSoilUnitText } from "../shared/soil/units";

export const soil = {

    SoilMapView,

    SoilAnalysisType,

    getMorganAttribute,
    getMorganIndexTextFromValue,
    getSoilUnitOption,
    getSoilUnitOptions,
    getSoilUnitLabel,
    getSoilUnitText,
    convertAnalysisAttributeToUnit,
    convertMorganToOlsen,
    convertOlsenToMorgan,

    colors: {
        getSoilColors,
        getMorganColor,
        getMorganColors,
        getMorganKey,
        getValueIndex,
        getGaugeStyle
    },

    plan: {
        vessOptions,
        infiltrationRateOptions,
        wormTypeOptions
    },

    conversions

}